var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 1.83301H4.00033C3.6467 1.83301 3.30756 1.97348 3.05752 2.22353C2.80747 2.47358 2.66699 2.81272 2.66699 3.16634V13.833C2.66699 14.1866 2.80747 14.5258 3.05752 14.7758C3.30756 15.0259 3.6467 15.1663 4.00033 15.1663H12.0003C12.3539 15.1663 12.6931 15.0259 12.9431 14.7758C13.1932 14.5258 13.3337 14.1866 13.3337 13.833V5.83301M9.33366 1.83301L13.3337 5.83301M9.33366 1.83301L9.33366 5.83301H13.3337M10.667 9.16634H5.33366M10.667 11.833H5.33366M6.66699 6.49967H5.33366",
    stroke: "#362044",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.40d3cfb86f784b15d54feacd07c81e8c.svg";
export { ForwardRef as ReactComponent };